<template>
	<div class="quantity-title">
		<div><slot></slot></div>
		<TeamingChip class="quantity-title__count" :text="quantityText" />
	</div>
</template>

<script>
import { TeamingChip } from "@teaming/common-ui";
export default {
	name: "QuantityTitle",
	components: {
		TeamingChip,
	},
	props: {
		howMany: {
			type: [ Number, String, ],
			required: true,
		},
	},
	computed: {
		quantityText() {
			return `${ this.howMany }`;
		},
	},
};
</script>

<style lang="scss" scoped>
$quantity-title-count-font-color: $color1-500;
$quantity-title-count-background-color: $color1-100;

.quantity-title {
	display: flex;
	justify-content: center;

	@include for-size('md') {
		justify-content: flex-start;
	}
}

.quantity-title__count {
	font-weight: 600;
	color: $quantity-title-count-font-color;
	background: $quantity-title-count-background-color;
	border-radius: 1.5rem;
	margin-left: 0.5rem;
	padding-left: 0.5rem;
	padding-right: 0.5rem;
}
</style>
